import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    LoadingDots,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

import styles from './Price.scss';

function Price(props) {
    const {
        className = '',
        i18nMoney,
        liveChecksInProgress = false,
        pricing,
        t,
        totalDiscount,
    } = props;

    return (
        <div className={className}>
            {liveChecksInProgress
                ? (
                    <LoadingDots className={styles.loadingDots} />
                )
                : (<>
                    {!!totalDiscount && <span
                        aria-label={t('baseApp:price')}
                        aria-live="polite"
                        className={styles.discounted}
                    >
                        {pricing
                            ? i18nMoney.format(i18nMoney(pricing).getTotalPrice() + totalDiscount)
                            : ''}
                    </span>}
                    <span
                        aria-label={t('baseApp:price')}
                        aria-live="polite"
                        className={classNames(styles.amount, {
                            [styles.slash]: !!totalDiscount,
                        })}
                    >
                        {pricing
                            ? i18nMoney.format(i18nMoney(pricing).getTotalPrice())
                            : ''}
                    </span>
                </>
                )}
        </div>
    );
}

Price.propTypes = {
    className: PropTypes.string,
    i18nMoney: PropTypes.func,
    liveChecksInProgress: PropTypes.bool,
    pricing: PropTypes.arrayOf(PropTypes.object),
    t: PropTypes.func,
    totalDiscount: PropTypes.number,
};

export {
    Price,
};
export default localize(Price, ['t', 'i18nMoney']);
